import api from "@/lib/api";
import { extensionFor } from "@/hooks/useAudioRecorder";

/** Upload a voice recording (Blob) as kind=voice. Resolves to the backend file record. */
export async function uploadAudio(blob, { durationS, refId, onProgress } = {}) {
  const fd = new FormData();
  const ext = extensionFor(blob.type);
  fd.append("file", blob, `opptak.${ext}`);
  fd.append("kind", "voice");
  if (durationS != null) fd.append("duration_s", String(Math.round(durationS * 10) / 10));
  if (refId) fd.append("ref_id", refId);
  const res = await api.post("/files/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return res.data;
}

/** Transcribe (whisper-1) + structure an uploaded recording into report fields. */
export async function analyseVoiceReport({ fileId, transcript, reportType, machineId, checklist, today }) {
  const res = await api.post(
    "/ai/voice-report",
    {
      file_id: fileId || null,
      transcript: transcript || null,
      report_type: reportType,
      machine_id: machineId || null,
      checklist: checklist || [],
      today,
    },
    { timeout: 180000 }
  );
  return res.data;
}
